import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AccountPlayerHeader = ({ backLink }) => {
  return (
    <div className='u-margin-top--base u-margin-bottom--large'>
      <Link className='o-sp-button o-sp-button--back' to={backLink}>
        <i className='sp-icon-arrow-left'></i>&nbsp;Back to all Children
      </Link>
    </div>
  );
}

AccountPlayerHeader.propTypes = {
  backLink: PropTypes.object.isRequired,
}

export default AccountPlayerHeader;
